import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignUnfollowHandoff } from '@/pages/workspaces/automations/[campaignId]/overview/routing';

function JourneysCampaignsUnfollowRoute() {
  const { campaignId } = Route.useParams();
  return <JourneysCampaignUnfollowHandoff campaignId={campaignId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/unfollow')(
  {
    component: JourneysCampaignsUnfollowRoute,
  },
);
